<template>
  <div>
    <!-- Floating WhatsApp Button -->
    <button class="wa-fab" @click="toggleForm" aria-label="Tulis Pesan ke WA">
      <img :src="Whatsapp" alt="Chat WA" />
    </button>

    <!-- Floating Form -->
    <transition name="slide-fade">
      <div v-if="showForm" class="wa-floating-form" ref="modalRef">
        <h3>Chat via WhatsApp</h3>
        <input
          type="text"
          v-model="form.nama"
          placeholder="Nama"
          @keydown.enter="focusNext"
          ref="namaInput"
        />
        <input
          type="text"
          v-model="form.judul"
          placeholder="Judul"
          @keydown.enter="focusNext"
          ref="judulInput"
        />
        <textarea
          v-model="form.pesan"
          placeholder="Pesan"
          rows="5"
          @keydown.ctrl.enter="submitForm"
          ref="pesanTextarea"
        ></textarea>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        <button @click="submitForm" :disabled="isSubmitting">
          {{ isSubmitting ? "Mengirim..." : "Kirim ke WhatsApp" }}
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import Whatsapp from "@/assets/images/landing_page/whatsapp.png";

export default {
  name: "FabWhatsapp",
  data() {
    return {
      showForm: false,
      form: {
        nama: "",
        judul: "",
        pesan: "",
      },
      Whatsapp,
      errorMessage: "",
      isSubmitting: false,
    };
  },
  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
      this.errorMessage = ""; // Clear error saat buka form

      if (this.showForm) {
        // Auto focus ke input nama saat form dibuka
        this.$nextTick(() => {
          if (this.$refs.namaInput) {
            this.$refs.namaInput.focus();
          }
        });
      }
    },

    // Fungsi untuk pindah focus dengan Enter
    focusNext(event) {
      const currentRef = event.target;
      if (currentRef === this.$refs.namaInput) {
        this.$refs.judulInput.focus();
      } else if (currentRef === this.$refs.judulInput) {
        this.$refs.pesanTextarea.focus();
      }
    },

    // Validasi form yang lebih detail
    validateForm() {
      // Reset error message
      this.errorMessage = "";

      if (!this.form.nama.trim()) {
        this.errorMessage = "Nama harus diisi.";
        this.$refs.namaInput.focus();
        return false;
      }

      if (this.form.nama.trim().length < 2) {
        this.errorMessage = "Nama minimal 2 karakter.";
        this.$refs.namaInput.focus();
        return false;
      }

      if (!this.form.judul.trim()) {
        this.errorMessage = "Judul harus diisi.";
        this.$refs.judulInput.focus();
        return false;
      }

      if (!this.form.pesan.trim()) {
        this.errorMessage = "Pesan harus diisi.";
        this.$refs.pesanTextarea.focus();
        return false;
      }

      if (this.form.pesan.trim().length < 10) {
        this.errorMessage = "Pesan minimal 10 karakter.";
        this.$refs.pesanTextarea.focus();
        return false;
      }

      return true;
    },

    async submitForm() {
      // Cegah double submit
      if (this.isSubmitting) return;

      // Validasi form
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      try {
        // Simulasi delay untuk UX yang lebih baik
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Format pesan yang lebih rapi
        const message = `Halo, saya ${this.form.nama.trim()}

*Judul:* ${this.form.judul.trim()}

*Pesan:*
${this.form.pesan.trim()}

---
Dikirim melalui website Efunding`;

        const whatsappURL = `https://wa.me/62818227070?text=${encodeURIComponent(
          message
        )}`;

        // Buka WhatsApp
        window.open(whatsappURL, "_blank");

        // Reset form dan tutup modal
        this.resetForm();
      } catch (error) {
        this.errorMessage = "Terjadi kesalahan. Silakan coba lagi.";
      } finally {
        this.isSubmitting = false;
      }
    },

    // Reset form
    resetForm() {
      this.form = { nama: "", judul: "", pesan: "" };
      this.errorMessage = "";
      this.showForm = false;
    },

    // Handle click outside untuk tutup modal
    handleClickOutside(event) {
      const modal = this.$refs.modalRef;
      const fabButton = event.target.closest(".wa-fab");

      if (modal && !modal.contains(event.target) && !fabButton) {
        this.showForm = false;
        this.errorMessage = "";
      }
    },

    // Handle ESC key untuk tutup modal
    handleEscapeKey(event) {
      if (event.key === "Escape" && this.showForm) {
        this.showForm = false;
        this.errorMessage = "";
      }
    },

    // Clear error saat user mulai mengetik
    clearErrorOnInput() {
      if (this.errorMessage) {
        this.errorMessage = "";
      }
    },
  },

  watch: {
    // Monitor perubahan form untuk clear error
    "form.nama"() {
      this.clearErrorOnInput();
    },
    "form.judul"() {
      this.clearErrorOnInput();
    },
    "form.pesan"() {
      this.clearErrorOnInput();
    },

    // Handle event listeners
    showForm(newVal) {
      if (newVal) {
        // Tambah event listeners saat form dibuka
        document.addEventListener("click", this.handleClickOutside);
        document.addEventListener("keydown", this.handleEscapeKey);
      } else {
        // Hapus event listeners saat form ditutup
        document.removeEventListener("click", this.handleClickOutside);
        document.removeEventListener("keydown", this.handleEscapeKey);
      }
    },
  },

  // Cleanup saat component di-destroy
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleEscapeKey);
  },
};
</script>

<style scoped>
/* Floating WhatsApp FAB */
.wa-fab {
  position: fixed;
  bottom: 30px;
  right: 5px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 999;
  transition: transform 0.2s;
}

.wa-fab:hover {
  transform: scale(1.1);
}

.wa-fab img {
  width: 70px;
  height: 70px;
}

/* Floating Form */
.wa-floating-form {
  position: fixed;
  bottom: 45px;
  right: 70px;
  width: 300px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: slideFadeIn 0.3s ease forwards;
  z-index: 999;
}

.wa-floating-form h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #075e54;
}

/* Input and Textarea */
.wa-floating-form input,
.wa-floating-form textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box; /* Tambahan untuk mencegah overflow */
}

.wa-floating-form input:focus,
.wa-floating-form textarea:focus {
  border-color: #004990;
  box-shadow: 0 0 0 2px rgba(0, 73, 144, 0.2);
  outline: none;
}

/* Button */
.wa-floating-form button {
  background-color: #25d366;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 25px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  box-shadow: 0 4px 10px rgba(37, 211, 102, 0.3);
}

.wa-floating-form button:hover:not(:disabled) {
  background-color: #1ebe54;
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(37, 211, 102, 0.4);
}

/* Disabled state untuk button */
.wa-floating-form button:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Animation */
@keyframes slideFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.error-message {
  color: #e53935;
  font-size: 10px;
  margin: -5px 0 5px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Fab.vue